"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Shade = _styledComponents.default.div.withConfig({
  displayName: "Shade",
  componentId: "gmwbqd-0"
})(["position:fixed;z-index:2;right:0;bottom:0;left:0;top:0;height:100vh;background:transparent;backdrop-filter:none;"]);

var Nav = _styledComponents.default.div.withConfig({
  displayName: "Nav",
  componentId: "gmwbqd-1"
})(["position:relative;nav{position:absolute;z-index:3;width:", ";", ":0;top:110%;transform-origin:top right;transform:", ";background:", ";overflow:auto;height:auto;border-radius:4px;border:1px solid #d8d8d8;box-shadow:0 4px 12px 1px ", ";ul{width:calc(", " - 2px);}ul li:last-child{border-bottom:0;}}"], function (_ref) {
  var navWidth = _ref.navWidth;
  return navWidth;
}, function (_ref2) {
  var navAlign = _ref2.navAlign;
  return navAlign === 'left' ? 'right' : 'left';
}, function (_ref3) {
  var open = _ref3.open;
  return open ? 'rotate3d(1, 0, 0, 0deg)' : 'rotate3d(1, 0, 0, 90deg)';
}, (0, _helpers.color)('white'), (0, _helpers.colorToAlpha)('black', 0.1), function (_ref4) {
  var navWidth = _ref4.navWidth;
  return navWidth;
});

var DropdownMenu = function DropdownMenu(_ref5) {
  var children = _ref5.children,
      Trigger = _ref5.trigger,
      className = _ref5.className,
      _ref5$navAlign = _ref5.navAlign,
      navAlign = _ref5$navAlign === void 0 ? 'right' : _ref5$navAlign,
      _ref5$navWidth = _ref5.navWidth,
      navWidth = _ref5$navWidth === void 0 ? '322px' : _ref5$navWidth,
      onOpen = _ref5.onOpen,
      isOpen = _ref5.isOpen,
      setIsOpen = _ref5.setIsOpen;
  (0, _react.useEffect)(function () {
    setIsOpen(false);
  }, [window.location.href]);

  var toggleMe = function toggleMe() {
    !isOpen && onOpen && onOpen();
    setIsOpen(function (state) {
      return !state;
    });
  };

  var navProps = {
    className: className,
    navAlign: navAlign,
    navWidth: navWidth,
    open: isOpen
  };
  return _react.default.createElement(_react.default.Fragment, null, isOpen && _react.default.createElement(Shade, {
    onClick: toggleMe
  }), _react.default.createElement(Nav, navProps, _react.default.createElement(Trigger, {
    open: isOpen,
    onClick: toggleMe
  }), children));
};

var _default = DropdownMenu;
exports.default = _default;